import React, { useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { myConfig } from "../../../config";

const ReCaptcha: React.FC<{
  setToken: (token: string) => void;
  myRef: any;
}> = (props) => {
  const sitekey = myConfig.captchaSiteKey;
  const onChange = (value: string) => {
    props.setToken(value);
  };

  return (
    <ReCAPTCHA
      sitekey={sitekey}
      onChange={onChange}
      ref={props.myRef}
      size="invisible"
      badge="bottomleft"
    />
  );
};

export default ReCaptcha;
